import {Toast} from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState, useRef } from "react";
import { CatalogProductNew } from "../../Product/CatalogProductNew/CatalogProductNew";
import { LubematchVariantCard } from "../LubematchProductCard/LubematchVariantCard";
import { useCartContext } from "../../../Context/CartContext";
import styles from './LubematchRecommendation.module.css'

const TIER_PRIORITY = ['Premium', 'Standard', 'Alternative'];
const getTierOrderIndex = (tierName = "") => {
    const idx = TIER_PRIORITY.indexOf(tierName);
    return idx === -1 ? TIER_PRIORITY.length : idx;
};
const getTierClassName = (stylesRef, tierName = '') => {
    switch(tierName){
        case 'Premium':
            return stylesRef.tierPremiumLabel;
        case 'Standard':
            return stylesRef.tierStandardLabel;
        case 'Alternative':
            return stylesRef.tierAlternativeLabel;
        default:
            return '';
    }
};

export const LubematchRecommendation = ({recommendationList, hasSearched = false, loading = false}) => {

    const toast = useRef(null);
    const {cart, getCart} = useCartContext();
    const [groupedRecommendationList, setGroupedRecommendationList] = useState([])
    const [collapsedGroups, setCollapsedGroups] = useState({});

    useEffect(() => {
        const preparedList = prepareRecommendationList2();
        setGroupedRecommendationList(preparedList)
    },[cart, recommendationList])

    const prepareRecommendationList2 = () => {
        const groups = new Map();

        for (const item of recommendationList) {
            const key = item.name;

            if (!groups.has(key)) {
                groups.set(key, [item]); // создаём массив элементов с одинаковым именем
            } else {
                groups.get(key).push(item);
            }
        }

        // преобразуем в нужную структуру
        const solidGroup = Array.from(groups.entries()).map(([name, groupItems]) => {
            if (groupItems.length === 1) {
                // только один элемент → options пустой
                return {
                    ...groupItems[0],
                    options: []
                };
            }

            // несколько элементов → options = массив похожих элементов
            return {
                ...groupItems[0], // берём основные свойства из первого
                options: groupItems
            };
        });

        console.log(`solidGroup before cart count: `, solidGroup);

        solidGroup.forEach((group) => {
            if(group.options && group.options.length > 0){
                group.options.forEach((option) => {
                    option.product.forEach((shellProduct) => {
                        shellProduct.lkProductList = getListProductCountInCart(getCart(), shellProduct.lkProductList);
                    })
                })
            }
            else{
                group.product.forEach((shellProduct) => {
                    shellProduct.lkProductList = getListProductCountInCart(getCart(), shellProduct.lkProductList);
                })
            }
        })
        console.log(`solidGroup: `, solidGroup);

        const hasShellProducts = (list = []) => Array.isArray(list) && list.length > 0;
        const hasLkMatches = (list = []) => Array.isArray(list) && list.some(item => Array.isArray(item.lkProductList) && item.lkProductList.length > 0);

        const checkedGroups = solidGroup.map(group => {
            const options = Array.isArray(group.options) ? group.options : [];
            const hasShellInOptions = options.some(option => hasShellProducts(option.product));
            const hasLkInOptions = options.some(option => hasLkMatches(option.product));

            return {
                ...group,
                hasShellRecommendationProducts: hasShellProducts(group.product) || hasShellInOptions,
                hasLkProducts: hasLkMatches(group.product) || hasLkInOptions
            };
        });

        console.log(`checkedGroups: `, checkedGroups);

        return checkedGroups;
    }
     
    const getListProductCountInCart = (cart, productList = null) => {
        if(cart && productList !== null && productList.length > 0){
            const actualCart = JSON.parse(getCart());
            const prodsInCart = actualCart.BaseOrder;
       
            const filteredProductsWithCountInCart = _.cloneDeep(productList);
       
            filteredProductsWithCountInCart.forEach((product, index) => {
            const findProduct = prodsInCart.find(item => item.id === product.Id)
       
            if(findProduct){
                product.countInCart = findProduct.count;
                    console.log(product.ProductName, product.countInCart)
                }
                else{
                    product.countInCart = 0;
                }
            })
       
            return filteredProductsWithCountInCart;
        }
        return productList;
        
    }

    const getDisplayCapacity = (item = {}) => item?.Display_Capacity || item?.display_capacity || '';
    const getDisplayOptionLabel = (item = {}) => item?.Display_Coption || item?.display_coption || '';
    const getGroupKey = (recommendation, index) => `${recommendation['@id'] || recommendation.name || 'group'}_${index}`;
    const getTierName = (product = {}) => product['@tier_name'] || product.TierName || '';
    const toggleGroup = (key) => {
        setCollapsedGroups(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };
    const handleHeaderKeyDown = (event, key) => {
        if(event.key === 'Enter' || event.key === ' '){
            event.preventDefault();
            toggleGroup(key);
        }
    };
    const renderAppNotes = (notes = []) => {
        if(!Array.isArray(notes) || notes.length === 0) return null;

        return (
            <div className={styles.notesWrapper}>
                <div className={styles.notesTitle}>Примітка</div>
                <ul className={styles.notesList}>
                    {notes.map((note, idx) => (
                        <span key={`${note?.Id || note?.['@id'] || idx}`}>
                            {idx+1}. {note?.Text || note?.text}
                        </span>
                    ))}
                </ul>
            </div>
        )
    }

    const renderTierCards = (products = []) => {
        if(!Array.isArray(products) || products.length === 0) return [];

        return products.map((shellProduct, idx) => {
            if(!shellProduct?.lkProductList || shellProduct.lkProductList.length === 0){
                return null;
            }

            const tierName = shellProduct['@tier_name'] || shellProduct.TierName || '';
            const tierClassName = getTierClassName(styles, tierName);

            return (
                <div className={styles.tierWrapper} key={`${shellProduct['@id'] || shellProduct.external_id || idx}`}>
                    <div className={`${styles.tierLabel} ${tierClassName}`}>{tierName}
                        {tierName === 'Premium' ? 
                            <div className={styles.sparkContainer}>
                                <div className={styles.spark}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                                            d="M3 12c6.268 0 9-2.637 9-9c0 6.363 2.713 9 9 9c-6.287 0-9 2.713-9 9c0-6.287-2.732-9-9-9Z"/>
                                    </svg>
                                </div>
                                <div className={styles.spark}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                                            d="M3 12c6.268 0 9-2.637 9-9c0 6.363 2.713 9 9 9c-6.287 0-9 2.713-9 9c0-6.287-2.732-9-9-9Z"/>
                                    </svg>
                                </div>
                                <div className={styles.spark}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                                            d="M3 12c6.268 0 9-2.637 9-9c0 6.363 2.713 9 9 9c-6.287 0-9 2.713-9 9c0-6.287-2.732-9-9-9Z"/>
                                    </svg>
                                </div>
                            </div>
                        : null}
                    </div>
                    <div className={styles.productList}>
                        {groupProductsByBaseName(shellProduct.lkProductList).map((group, gIdx) => (
                            <LubematchVariantCard key={(group[0]?.Id || 'group') + '_' + gIdx} variants={group} toast={toast} />
                        ))}
                    </div>
                </div>
            );
        }).filter(Boolean);
    }

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
                <ProgressSpinner strokeWidth="4" />
            </div>
        );
    }

    if(!groupedRecommendationList || !groupedRecommendationList.length)
        return hasSearched ? <div>Не знайдено рекомендацій за вашим авто</div> : null;

    return (
        <div className={styles.recommendationGroupsWrapper}>
            <Toast ref={toast}></Toast>
            {groupedRecommendationList.map((recommendation, index) => {
                const groupKey = getGroupKey(recommendation, index);
                const isCollapsed = !!collapsedGroups[groupKey];
                const baseCapacity = getDisplayCapacity(recommendation);
                let bodyContent = null;

                if(recommendation.hasLkProducts){
                    const hasOptions = Array.isArray(recommendation.options) && recommendation.options.length > 0;

                    if(!hasOptions){
                        const tierCards = renderTierCards(recommendation.product);
                        if(!tierCards || tierCards.length === 0){
                            return null;
                        }

                        bodyContent = (
                            <>
                                <div className={styles.tierListWrapper}>
                                    {tierCards}
                                </div>
                                {renderAppNotes(recommendation.AppNotes)}
                            </>
                        );
                    } else {
                        const optionBlocks = recommendation.options.map((option, optIdx) => {
                            const optionTierCards = renderTierCards(option.product);
                            const optionCapacity = getDisplayCapacity(option);
                            const optionLabel = getDisplayOptionLabel(option);
                            const hasTierCards = optionTierCards && optionTierCards.length > 0;
                            const hasShellProducts = Array.isArray(option.product) && option.product.length > 0;

                            return (
                                <div className={styles.optionGroupWrapper} key={`${option['@id'] || optIdx}`}>
                                    <div className={styles.optionHeader}>
                                        <span className={styles.optionName}>{option.name}</span>
                                        <div className={styles.optionMeta}>
                                            {optionLabel && <span className={styles.optionTag}>{optionLabel}</span>}
                                            {optionCapacity && <span className={styles.optionCapacity}>{optionCapacity} (л)</span>}
                                        </div>
                                    </div>
                                    <div className={styles.variantListOrEmpty}>
                                        {hasTierCards ? (
                                            <div className={styles.tierListWrapper}>
                                                {optionTierCards}
                                            </div>
                                        ) : (
                                            <div className={styles.optionEmptyState}>
                                                {hasShellProducts ? (
                                                    <div className={styles.shellSuggestion}>
                                                        <div className={styles.shellSuggestionTitle}>Запропоновані продукти:</div>
                                                        <div className={styles.shellSuggestionList}>
                                                            {option.product.map((shellProduct, idx) => (
                                                                <div key={idx} className={styles.shellSuggestionItem}>
                                                                    <span className={styles.shellSuggestionName}>{shellProduct.name}</span>
                                                                    {option.display_coption && <span className={styles.shellSuggestionMeta}>{option.display_coption}</span>}
                                                                    {option.display_capacity && <span className={styles.shellSuggestionMeta}>{option.display_capacity}</span>}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <h6>На жаль, за цією конфігурацією немає рекомендацій з бази Shell</h6>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    {renderAppNotes(option.AppNotes)}
                                </div>
                            )
                        });

                        bodyContent = (
                            <div className={styles.recommedationOptionWrapper}>
                                {optionBlocks}
                            </div>
                        );
                    }
                }
                else{
                    const hasOptions = Array.isArray(recommendation.options) && recommendation.options.length > 0;
                    const renderShellProductsList = (products = []) => {
                        if(!Array.isArray(products) || products.length === 0){
                            return <div className={styles.subgroupEmpty}>Немає запропонованих продуктів</div>;
                        }

                        return (
                            <div className={styles.shellProductsSimple}>
                                {products.map((shellProduct, idx) => (
                                    <div key={idx} className={styles.shellProductLine}>
                                        <span className={styles.shellProductName}>{shellProduct.name}</span>
                                        {getTierName(shellProduct) && (() => {
                                            const tierName = getTierName(shellProduct);
                                            const tierClassName = getTierClassName(styles, tierName);
                                            return (
                                                <span className={`${styles.tierLabel} ${styles.shellProductTier} ${tierClassName}`}>
                                                    {tierName}
                                                    {tierName === 'Premium' ? (
                                                        <div className={styles.sparkContainer}>
                                                            <div className={styles.spark}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                                    <path fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                                                                        d="M3 12c6.268 0 9-2.637 9-9c0 6.363 2.713 9 9 9c-6.287 0-9 2.713-9 9c0-6.287-2.732-9-9-9Z"/>
                                                                </svg>
                                                            </div>
                                                            <div className={styles.spark}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                                    <path fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                                                                        d="M3 12c6.268 0 9-2.637 9-9c0 6.363 2.713 9 9 9c-6.287 0-9 2.713-9 9c0-6.287-2.732-9-9-9Z"/>
                                                                </svg>
                                                            </div>
                                                            <div className={styles.spark}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                                    <path fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                                                                        d="M3 12c6.268 0 9-2.637 9-9c0 6.363 2.713 9 9 9c-6.287 0-9 2.713-9 9c0-6.287-2.732-9-9-9Z"/>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </span>
                                            );
                                        })()}
                                    </div>
                                ))}
                            </div>
                        );
                    };

                    bodyContent = (
                        <div className={styles.emptyState}>
                            {recommendation.hasShellRecommendationProducts ? 
                                (
                                    hasOptions ? (
                                        <div className={styles.shellSubgroupList}>
                                            {recommendation.options.map((option, optIdx) => {
                                                const optionCapacity = getDisplayCapacity(option);
                                                const optionLabel = getDisplayOptionLabel(option);

                                                return(
                                                    <div className={styles.shellSubgroupCard} key={`${option['@id'] || optIdx}`}>
                                                        <div className={styles.shellSubgroupHeader}>
                                                            <span className={styles.subgroupLabel}>Запропоновані продукти</span>
                                                            <div className={styles.subgroupMeta}>
                                                                {optionLabel && <span className={styles.subgroupTag}>{optionLabel}</span>}
                                                                {optionCapacity && <span className={styles.subgroupTag}>{optionCapacity} (л)</span>}
                                                            </div>
                                                        </div>
                                                        {renderShellProductsList(option.product)}
                                                        {renderAppNotes(option.AppNotes)}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    ) : (
                                        <div className={styles.shellSubgroupCard}>
                                            <div className={styles.shellSubgroupHeader}>
                                                <span className={styles.subgroupLabel}>Запропоновані продукти</span>
                                                <div className={styles.subgroupMeta}>
                                                    {(recommendation.display_coption || recommendation.Display_Coption) && <span className={styles.subgroupTag}>{recommendation.display_coption || recommendation.Display_Coption}</span>}
                                                    {(baseCapacity || recommendation.Display_Capacity) && <span className={styles.subgroupTag}>{baseCapacity || recommendation.Display_Capacity}(л)</span>}
                                                </div>
                                            </div>
                                            {renderShellProductsList(recommendation.product)}
                                        </div>
                                    )
                                )
                                :
                                <h6>На жаль, за вашим авто не знайдено рекомендацій у базі Shell</h6>
                            }
                            {!hasOptions && renderAppNotes(recommendation.AppNotes)}
                        </div>
                    );
                }

                if(!bodyContent) return null;

                const displayMeta = [
                    recommendation.display_coption || recommendation.Display_Coption || '',
                    baseCapacity || recommendation.Display_Capacity || ''
                ].filter(Boolean).join(' | ');

                return (
                    <div className={`${styles.recommendationGroupWrapper} ${isCollapsed ? styles.groupCollapsed : ''}`} key={groupKey}>
                        <div
                            className={styles.groupHeader}
                            role="button"
                            tabIndex={0}
                            onClick={() => toggleGroup(groupKey)}
                            onKeyDown={(event) => handleHeaderKeyDown(event, groupKey)}
                        >
                            <div className={styles.groupTitleBlock}>
                                <div className={styles.groupName}>{recommendation.name}</div>
                                {(displayMeta && recommendation?.options?.length === 0) && <div className={styles.groupMeta}>{displayMeta} (л)</div>}
                            </div>
                            <span className={`${styles.collapseIcon} ${isCollapsed ? styles.iconCollapsed : ''}`}></span>
                        </div>
                        {!isCollapsed && (
                            <div className={styles.groupBody}>
                                {bodyContent}
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
}
// Groups products that have identical base names (ignoring trailing volume like ", 5л")
function groupProductsByBaseName(list = []){
    if(!Array.isArray(list) || list.length === 0) return [];
    const normalize = (name) => {
        if(!name) return '';
        // remove trailing comma + volume like ", 5л" or ", 5 л" or ", 5.5л"
        const trimmed = name.trim();
        const withoutVolume = trimmed.replace(/,\s*\d+(?:[\.,]\d+)?\s*л$/i, '');
        return withoutVolume.trim();
    }

    const groups = {};
    list.forEach(p => {
        const key = normalize(p.ProductName);
        if(!groups[key]) groups[key] = [];
        groups[key].push(p);
    });

    // sort each group by numeric volume if available
    const parseVol = (p) => {
        if(p && p.Volume != null) return Number(p.Volume) || 0;
        const m = (p?.ProductName || '').match(/,\s*(\d+(?:[\.,]\d+)?)\s*л$/i);
        if(m){
            return Number(String(m[1]).replace(',', '.')) || 0;
        }
        return 0;
    };

    return Object.values(groups).map(arr => arr.sort((a,b)=> parseVol(a) - parseVol(b)));
}
